document.querySelectorAll('[data-block-type="stock-status-cards"]').forEach((initialElement) => {
  const rerenderElement = initialElement.closest('product-rerender');
  const formId = rerenderElement?.getAttribute('observe-form');
  const form = formId && document.forms[formId];
  const blockId = initialElement.getAttribute('data-block-id');

  if (!form) return;

  form.addEventListener('product:rerender', (event) => {
    const currentElement = rerenderElement.querySelector(`[data-block-type="stock-status-cards"][data-block-id="${blockId}"]`);
    const matchingBlock = event.detail.htmlFragment.querySelector(`[data-block-type="stock-status-cards"][data-block-id="${blockId}"]`);

    if (currentElement && matchingBlock) {
      currentElement.replaceWith(matchingBlock);
    }
  });
});
